
    import { computed, defineComponent } from 'vue'

    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        emits: [
            'app-discovered',
            'closed'
        ],
        setup () {
            const sharedSettingsStore = useSharedSettingsStore()
            const playStoreLink = computed(() => sharedSettingsStore.setting('player-android'))

            return {
                playStoreLink
            }
        }
    })
